import React from "react";
import StaticRenderer from "@emcm-ui/component-static-renderer";

const decorator = storyFn => (
  <StaticRenderer withoutMarkupContainerAttribute>{storyFn()}</StaticRenderer>
);

export default decorator;
